module.exports = __webpack_public_path__ + "static/img/eKuiper-logo.9eacd0e7.png";